
import React, { useState, useEffect, useRef, useCallback } from 'react';
import '../itemPage.css';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { convertColumnNameToPascalCase, handleDeleteRowCommon, useCartUtils } from '../ItemPageShared/ItemUtils';
import { useCart } from '../ItemPageShared/itemContext';
import { toast } from 'react-toastify';
import { GetItembyPasting } from '../../APIServices/ItemPageService/ItemPageThunk';
import DropdownInput from './DropDown';
const TableView = React.memo(({
    handleItemInputChange,
    setIsFetchingNextPage,
    itemSearchTerm,searchColumn,
    setIsDropdownOpen,
    isDropdownOpen,
    isFetchingNextPage,
    setDueDate,
    DueDate,
    setRemarks,
    handleItemSelect,
    setCallInProgress,
    fetchItemsBySearch,
    setRows,
    rows,
    handleDeleteRow
}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { additionalData } = location.state || {};
    const { loading, error, GetCartItm,GetItmBySearch, ItemDetailsbyPasting } = useSelector((state) => state.itemPage);
    const [rowCount, setRowCount] = useState(0);
    
    const dropdownRef = useRef(null);
    const user = sessionStorage.getItem('user');
    const encrpt = JSON.parse(user);
    const excludedColumns = ['onHand', 'itmsGrpCod', 'onOrder', 'isCommited'];
    const columns = ['item_Code', 'item_Name', 'quantity', 'uom', 'uom_multiple', 'price', 'discount_Percentage', 'price_After_Discount', 'Total']
    const [isOtherCustomer, setIsOtherCustomer] = useState(false);
    const LeadDetails = sessionStorage.getItem('CustomerDetails');
    const { handleQuantityChange } = useCartUtils();
    const { cart, setCartItems,
        page, searchResults,setPage,setSearchResults
    } = useCart();
    useEffect(() => {
        if (LeadDetails) {
            const lead = JSON.parse(LeadDetails);
            if (lead.CheckBox === 'checked') {
                setIsOtherCustomer(true);
            }
        }
    }, []);

    useEffect(() => {
        if (GetCartItm?.length > 0) {
            setCartItems(GetCartItm);
            GetCartItm.forEach(() => handleAddRowClick());
            setRemarks(GetCartItm[0]?.Remarks || "");
        }
    }, [GetCartItm, additionalData]);
 
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current && 
                !dropdownRef.current.contains(event.target)
            ) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            const message = "Are you sure you want to leave this pages?";
            event.returnValue = message;
            return message;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        if (!rows || rows.length === 0) {
            setRows([{}]);
        }
    }, []);
    const addRows = (count) => {
        setRows(prevRows => {
            const newRows = [...prevRows];
            for (let i = 0; i < count; i++) {
                newRows.push({}); // Add empty row objects
            }
            return newRows;
        });
    };
    // Handle the "Add Row" button click
    const handleAddRowClick = () => {
        addRows(rowCount + 1); // Add rows based on rowCount state
        setRowCount(0);
    };
    useEffect(() => {
        if (cart && cart.length > 0) {
            setRows(Array.from({ length: cart.length }, () => ({})));
        }
    }, [cart]);
    useEffect(() => {
        if (!cart || cart.length === 0) return;
        const lastRow = cart[cart.length - 1];
        if (!lastRow) return;
        const requiredFields = ['item_Code', 'item_Name', 'quantity'];
        const isLastRowFilled = requiredFields.every(field => {
            const value = lastRow[field];
            return value !== undefined && value !== null && value !== '';
        });
        if (isLastRowFilled) {
            handleAddRowClick();
        }
    }, [cart]);

    // const handleScroll = (e) => {
    //     const target = e.target;
    //     const scrollPosition = target.scrollTop + target.clientHeight;
    //     const reachedBottom = scrollPosition >= target.scrollHeight - 10;
      
    //     if ( reachedBottom &&!loading.GetItmBySearch &&!isFetchingNextPage) {
    //       setIsFetchingNextPage(true);
    //       setPage(prev => prev + 1);
    //     }
    //   }; 
    //   useEffect(() => {
    //     if (isFetchingNextPage) {
    //       fetchItemsBySearch(itemSearchTerm, page, searchColumn);
    //     }
    //   }, [page, isFetchingNextPage]);



    // const handleScroll = (e) => {
    //     const target = e.target;
    //     const scrollPosition = target.scrollTop + target.clientHeight;
    //     const reachedBottom = scrollPosition >= target.scrollHeight - 10; // small buffer
    //     if (
    //       reachedBottom &&
    //       !loading.GetItmBySearch &&!isFetchingNextPage
    //     ) {
    //         setIsFetchingNextPage(true);
    //       const nextPage = page + 1;
    //       setPage(nextPage);
    //       fetchItemsBySearch(itemSearchTerm, nextPage,searchColumn)
    //     }
    //   };
      
    //   useEffect(() => {
    //     const handleScrollEvent = (e) => handleScroll(e);
    //     window.addEventListener("scroll", handleScrollEvent);
    //     return () => {
    //       window.removeEventListener("scroll", handleScrollEvent);
    //     };
    //   }, [handleScroll]);
      
  
    const inputRefs = useRef({});
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const handleKeyDown = (e, rowIndex, column) => {
        const key = e.key;
        const dropdownOpen = isDropdownOpen && searchResults.length > 0;
        const currentRow = cart[rowIndex] || {};
        const moveNext = () => {
          const fields = ["item_Code", "item_Name", "quantity"];
          const empty = fields.find((f) => !currentRow[f]);
          const next = empty ? `${rowIndex}-${empty}` : `${rowIndex + 1}-item_Code`;
          inputRefs.current[next]?.focus();
        };
        if (dropdownOpen && ["ArrowDown", "ArrowUp", "Enter"].includes(key)) {
          e.preventDefault();
          if (key === "ArrowDown" || key === "ArrowUp") {
            setHighlightedIndex((prev) => {
              let next;
              if (key === "ArrowDown") {
                next = (prev + 1) % searchResults.length;
              } else {
                next = (prev - 1 + searchResults.length) % searchResults.length;
              }
              return next;
            });
          } else if (key === "Enter" && highlightedIndex >= 0) {
            handleItemSelect(searchResults[highlightedIndex], rowIndex, column);
            setHighlightedIndex(-1);
            setTimeout(moveNext, 50);
          }
          return;
        }
        if (key === "Enter") {
          e.preventDefault();
          moveNext();
        }
      };
      
      useEffect(() => {
    if (dropdownRef.current && highlightedIndex >= 0) {
        const container = dropdownRef.current;
        const item = container.children[highlightedIndex];
        if (item) {
            const itemTop = item.offsetTop;
            const itemBottom = itemTop + item.offsetHeight;
            const containerTop = container.scrollTop;
            const containerBottom = containerTop + container.offsetHeight;
            if (itemBottom > containerBottom) {
                container.scrollTop = itemBottom - container.offsetHeight;
            } else if (itemTop < containerTop) {
                container.scrollTop = itemTop;
            }
        }
    }
}, [highlightedIndex, dropdownRef]);
    
  



const handlePaste = (e, rowIndex, field) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text/plain")?.trim();
    if (!text) return;

    const lines = text.split(/\r?\n/);
    const errorMessages = new Set();
    const pastedItemCodes = new Set();
    const pastedItemNames = new Set();

    const parseLine = (line) => {
        const clean = line.trim();
        if (!clean) return { error: "Empty line detected" };
        const tokens = clean
            .split(/\t+|\s{2,}/)
            .map(t => t.trim())
            .filter(Boolean);

        if (tokens.length === 1) {
            if (field === "item_Code") return { itemCode: tokens[0] };
            if (field === "item_Name") return { itemName: tokens[0] };
            if (field === "quantity") return { quantity: tokens[0] };
        }

        let itemCode = "";
        let itemName = "";
        let quantity = "";
        const lastTokenIsNumber = /^\d+$/.test(tokens[tokens.length - 1]);

        if (field === "item_Code") {
            itemCode = tokens[0];
            quantity = lastTokenIsNumber ? tokens[tokens.length - 1] : "";
            itemName = tokens.slice(1, quantity ? -1 : undefined).join(" ").trim();
        } else if (field === "item_Name") {
            itemName = tokens[0];
            quantity = lastTokenIsNumber ? tokens[tokens.length - 1] : "";
            itemCode = tokens.length > 1 ? tokens.slice(1, quantity ? -1 : undefined).join(" ").trim() : "";
        } else if (field === "quantity") {
            quantity = tokens[0];  // only quantity
        }

        return { itemCode, itemName, quantity };
    };

    setCartItems((prev) => {
        const updated = [...prev];
        const existingCodes = new Set(prev.filter(r => r).map(r => r.item_Code));
        const newCodes = new Set();
        const newNames = new Set();
        let insertOffset = 0;

        for (const line of lines) {
            const parsed = parseLine(line);
            if (parsed.error) {
                errorMessages.add(parsed.error);
                continue;
            }

            const { itemCode, itemName, quantity } = parsed;
            const targetRow = rowIndex + insertOffset;
            if (!updated[targetRow]) updated[targetRow] = {};

            if (field === "quantity") {
                // Only update quantity, preserve existing itemCode/itemName
                updated[targetRow] = {
                    ...updated[targetRow],
                    quantity: quantity,
                    
                };
                // handleQuantityChange(
                //     { target: { value: quantity } },
                //     targetRow,
                //     "quantity"
                // );
            } else {
                if (itemCode && newCodes.has(itemCode)) {
                    errorMessages.add(`Duplicate pasted item code: "${itemCode}"`);
                    continue;
                }
                updated[targetRow] = {
                    ...updated[targetRow],
                    item_Code: itemCode,
                    item_Name: itemName,
                    quantity: quantity,
                };

                if (itemCode) {
                    newCodes.add(itemCode);
                    pastedItemCodes.add(itemCode);
                    existingCodes.add(itemCode);
                }
                if (itemName) {
                    newNames.add(itemName);
                    pastedItemNames.add(itemName);
                }
            }

            insertOffset++;
        }

        // Trigger API only if itemCode/itemName were pasted
        const codesToSend = pastedItemCodes.size > 0 ? [...pastedItemCodes].map(c => `'${c}'`).join(",") : null;
        const namesToSend = pastedItemNames.size > 0 ? [...pastedItemNames].map(n => `'${n}'`).join(",") : null;
        if (codesToSend || namesToSend) {
            setCallInProgress(prev => ({ ...prev, getPasteItems: true }));
            dispatch(GetItembyPasting({
                ItemCodes: codesToSend || "",
                ItemName: namesToSend || "",
            }));
        }

        return updated;
    });

    if (errorMessages.size > 0) {
        for (const msg of errorMessages) toast.error(msg);
    }
};


      
    const getInputValue = (rowIndex, column, columnPascal) =>  cart[rowIndex]?.[column] || "";
    const getPlaceholder = (rowIndex, column) =>
        column === "quantity" && !cart[rowIndex]?.quantity
            ? "Enter quantity"
            : `Search ${convertColumnNameToPascalCase(column)}`;
    const [activeCell, setActiveCell] = useState({ rowIndex: null, column: null });

    const handleInputChange = (e, rowIndex, column) => {
        const value = e.target.value;
        setActiveCell({ rowIndex, column });
        if (column === 'quantity') {
            const itemCode = cart[rowIndex]?.item_Code || '';
            const itemName = cart[rowIndex]?.item_Name || '';
            if (!itemCode || !itemName) {
                toast.error('Select Item Code and Item Name before entering Quantity');
                return;
            }
            handleQuantityChange(e, rowIndex, column);
        } else {
            handleItemInputChange(value, rowIndex, column); // For item_Code or item_Name
        }
    };
    console.log("searchResults",searchResults);
    return (
        <div className='table-maindiv col-12 gap-5 ps-2 pe-1'>
            <div className='col-9 table-subdiv'>
                <div className="row-count-section">
                    <button className="Addrow-btn" onClick={handleAddRowClick}>Add Rows</button>
                    <div className="CheckDatePicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                // label={}
                                className="PRPicker"
                                value={DueDate}
                                minDate={dayjs()}
                                onChange={(newValue) => {
                                    if (newValue && dayjs.isDayjs(newValue)) {
                                        setDueDate(newValue);
                                    }
                                }}
                                format="DD/MM/YYYY"
                            />
                        </LocalizationProvider>
                    </div>
                </div>
                <div className="matrix table-container">
                    <table className="modular-table-design">
                        <thead className="modular-table-header">
                            <tr >
                                <th className='modular-header'>Action</th>
                                {columns.map((column, idx) => {
                                    if (!excludedColumns.includes(column)) {
                                        const columnPascal = convertColumnNameToPascalCase(column);
                                        // Convert once per column
                                        return (
                                            <th className='modular-header' key={idx}>
                                                {columnPascal}
                                            </th>
                                        );
                                    }
                                    return null;
                                })}
                            </tr>
                        </thead>
                        <tbody className="modular-table-body ">
                            {rows?.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td>
                                        <IconButton
                                            onClick={() => handleDeleteRow(rowIndex)}
                                            className="delete-button"
                                            size="small"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </td>

                                    {columns.map((column, colIndex) => {
                                        if (excludedColumns.includes(column)) return null;
                                        const columnPascal = convertColumnNameToPascalCase(column);
                                        const value = getInputValue(rowIndex, column, columnPascal);
                                        const placeholder = getPlaceholder(rowIndex, column);
                                        // const disabled = isInputDisabled(rowIndex, columnPascal);
                                        const isDropdownColumn = ['item_Code', 'item_Name', 'quantity'].includes(column);
                                        return (
                                            <td className="alternate-color" key={colIndex}>
                                                {isDropdownColumn ? (
                                                    <DropdownInput
                                                        rowIndex={rowIndex}
                                                        column={column}
                                                        value={value}
                                                        placeholder={placeholder}
                                                        inputRefs={inputRefs}
                                                        // setSearchResults={setSearchResults}
                                                        // handleScroll={handleScroll}
                                                        handleChange={handleInputChange}
                                                        handleKeyDown={handleKeyDown}
                                                        handlePaste={handlePaste}
                                                        searchResults={searchResults}
                                                        highlightedIndex={highlightedIndex}
                                                        isDropdownOpen={isDropdownOpen}
                                                        loading={loading}
                                                        activeCell={activeCell}
                                                        setActiveCell={setActiveCell}
                                                        dropdownRef={dropdownRef}
                                                        handleItemSelect={handleItemSelect}
                                                    />
                                                ) : column === 'Total' ? (
                                                    <div>{cart[rowIndex]?.['total'] || ''}</div>
                                                ) : (
                                                    <div>{row[column] || cart[rowIndex]?.[column]}</div>
                                                )}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
});

export default TableView;
